import React, { useEffect, useState } from 'react';
import Show from './Show';
import { AgendaIcon } from '../../../eagerlyIcons/src/__generated__/icons';

import { parseEntities, parseDateDesktopShort } from '../../utils/helpers';

const BigTile = ({ movie, id, activeFilterDate, currentConfig, releaseDate, handleTagClick, animationDelay, detailPage }) => {
  const toSmallDateDisplay = (string) => {
    const stringArr = string.split(' ');
    if (stringArr.length <= 1) {
      //today, tomorrow
      return string;
    }
    const shortWeekday = stringArr[0].split('')[0] + stringArr[0].split('')[1];
    const shortMonth = stringArr[2].split('')[0] + stringArr[2].split('')[1] + stringArr[2].split('')[2];
    return shortWeekday + ' ' + stringArr[1] + ' ' + shortMonth;
  };

  //BIG

  return (
    <li className={`featured__item ${detailPage ? 'detailpage' : ''}`} key={id} style={animationDelay} id={`movie-${id}`} alt={movie.title}>
      <a className="featured__item_link" href={movie.permalink} alt={movie.title} aria-label={`meer informatie over ${movie.title}`}>
        <article className="agenda-item" alt={movie.title}>
          {!detailPage && (
            <div className="agenda-item__image-container">
              {movie.poster_mobile ? (
                <img src={movie.poster_mobile} alt={movie.title} className="agenda-item__image agenda-item__image-mobile " />
              ) : (
                <div className="agenda-item__image agenda-item__image-mobile"></div>
              )}
              {movie.poster_desktop ? (
                <img src={movie.poster_desktop} alt={movie.title} className="agenda-item__image agenda-item__image-desktop " />
              ) : (
                <div className="agenda-item__image agenda-item__image-desktop"></div>
              )}
            </div>
          )}
          <div className="agenda-item__content">
            <div className="agenda-item__tags">
              {Object.keys(movie.tags).map((tag, index) => {
                if (tag !== 'special-no-label')
                  return (
                    <div
                      key={index}
                      className="agenda-item__tags-label p"
                      data-value={movie.tags[tag]}
                      data-highlight={tag === 'special' ? 'true' : 'false'}
                      data-reverse={tag !== 'special' ? 'true' : 'false'}
                      //   onClick={() => handleTagClick(movie.tags[tag], true)} //only activate tag, not deactivate
                    >
                      {parseEntities(movie.tags[tag])}
                    </div>
                  );
              })}

              {movie.times[0].status_label && <div className="agenda-item__tags-label agenda-item__tags-label-status p">{movie.times[0].status_label}</div>}
            </div>

            <div className="agenda-item__day">
              <AgendaIcon />
              <time dateTime={parseDateDesktopShort(releaseDate).concat(` - ${movie.times[0].program_start.substring(8, 10)}:${movie.times[0].program_start.substring(10, 12)}`)}>
                {parseDateDesktopShort(releaseDate)} {` - ${movie.times[0].program_start.substring(8, 10)}:${movie.times[0].program_start.substring(10, 12)}`}
              </time>
              {movie.times[0].location && <>{` - ${movie.times[0].location}`}</>}
            </div>
            {!detailPage && (
              <>
                <h2 className="agenda-item__title" alt={movie.title}> {parseEntities(movie.title)}</h2>
                {movie.storyline && <h3 className="agenda-item__subtitle">{parseEntities(movie.storyline)}</h3>}
              </>
            )}
            {detailPage && typeof movie.times[0].door_open === 'string' && <h3 className="agenda-item__subtitle">{`Open: ${movie.times[0].door_open.substring(8, 10)}:${movie.times[0].door_open.substring(10, 12)}`}</h3>}
{/* a comment */}
            <div className="agenda-item__tickets">
              {movie.times[0].available && (
                <>
                  {detailPage && movie.times[0].price && (
                    <div className="agenda-item__price">
                      <p className="agenda-item__price--top">{`\u20AC ${movie.times[0].price}`}</p>
                      <p className="agenda-item__price--bottom">Incl. servicekosten & garderobe</p>
                    </div>
                  )}
                  {movie.times[0].ticket_link && (
                    <a href={movie.times[0].ticket_link} className="btn btn__ticket" aria-label={`tickets voor ${movie.title}`} target="_blank">
                      {detailPage ? 'Bestel Tickets' : 'Tickets'}
                    </a>
                  )}
                </>
              )}
            </div>
          </div>
        </article>
      </a>
    </li>
  );
};

export default BigTile;
